<template>
<!--  <h2>HomeLoggedOut</h2>-->
<!--  <NavBar></NavBar>-->
  <div v-if="showMenu">
    <LoginLevel1 v-if="showLoginLevel1" @goToLevel2="goToLevel2"  @goToDashboardNewUser="goToDashboard"></LoginLevel1>
    <LoginLevel2 v-if="showLoginLevel2" @goToDashboard="goToDashboard" :currentUsername="currentUsername"  ></LoginLevel2>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import LoginLevel1 from "@/components/LoginLevel1.vue";
import LoginLevel2 from "@/components/LoginLevel2.vue";
import {log} from "@/composables/useLog";
import store from "@/store";
import useLoginWithToken from "@/composables/useLoginWithToken";
import { saveToken, getToken } from "@/composables/useTokenStorage";
import { loadAllDbTranslations } from "@/composables/useLanguages";
import { landingPathForUser } from "@/composables/useClientLanding";
// import NavBar from "@/components/NavBar.vue";
// Components

export default defineComponent({
  name: 'HomeLoggedOut',
  components: {
    // NavBar,
    LoginLevel1,
    LoginLevel2

  },
  data() {
    return {
      loggedIn: false,
      showLoginLevel1: true,
      showLoginLevel2: false,
      currentUsername:'',
      token: null,
      showMenu: false
    }
  },
  methods:{
    goToLevel2(payload){
      log("inapoi in HomeLoggedOut am primit din loginLevel1 evenimentul goToLevel2 cu payloadul:")
      log(payload)
      if(!payload.error){
        this.currentUsername=payload.username
        log("scriem this.currentUsername="+this.currentUsername)
        this.showLoginLevel1= false
        this.showLoginLevel2= true
      }
    },

    async goToDashboard(payload){
      log("inapoi in HomeLoggedOut am primit din loginLevel2 evenimentul goToDashboard cu payloadul:")
      log(payload)
      this.currentUsername=payload.username
      store.commit('setUser', {user: payload.user})
      store.commit('setToken',{token:payload.token})
      store.commit('setLoggedIn',payload.loggedIn)
      // Save token based on cookie consent (localStorage if accepted, sessionStorage if rejected)
      saveToken(payload.token)
      // Load DB translation overrides
      await loadAllDbTranslations(payload.token)
      this.$router.push({path: landingPathForUser(payload.user)})
    }
  },

  created() {
    log('welcome in onBeforeMount: HomeLoggedOut')
    // Get token from appropriate storage based on cookie consent
    let storedToken = getToken()
    if(storedToken){
      log("calling with token found in storage!")
      log(storedToken)
      const {loginWithToken}=useLoginWithToken()
      loginWithToken(storedToken).then((result)=> {
        log("welcome back from loginWithToken(token)")
        log(result)
        if (result.error == true) {
          this.showMenu=true
          return
        } else {
          this.showMenu=false
          let user = result.user
          log(this.user)
          store.commit('setUser', {user: user})
          store.commit('setToken',{token:storedToken})
          store.commit('setLoggedIn',true)
          // Load DB translation overrides
          loadAllDbTranslations(storedToken)
          this.$router.replace({path: landingPathForUser(user)})
        }
      })
    }else{
      // alert("Not found token")
      log('nu am gasit nimic in localstorage')
      this.showMenu=true
    }
  }



});
</script>
